import { useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components/macro';
import { timeRangeConstants } from '../const';

import { CustomReportModalFormikValues, TIMEFRAME } from '../types';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from 'lib/components/SegmentedControl';
import { PillItem } from 'lib/components/SegmentedControl/types';

const Title = styled.h3`
font-size: 12px;
font-weight: 600;
line-height: 24px;
text-align: left;
color:${({ theme }) => theme.colors.neutral[80]}
margin-bottom:16px;
`;

interface IProps {
  setCurrentTimeFrame: React.Dispatch<React.SetStateAction<TIMEFRAME>>;
  currentTimeframe: TIMEFRAME;
  updateRangeValue: (rangeValue: string) => void;
  timeframeOptions: PillItem[];
}

export const SelectTimeframe = ({
  setCurrentTimeFrame,
  currentTimeframe,
  updateRangeValue,
  timeframeOptions,
}: IProps) => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext<CustomReportModalFormikValues>();

  const onChangeHandler = (newTab: TIMEFRAME) => {
    setCurrentTimeFrame(newTab);
    setFieldValue('startDate', new Date());
    setFieldValue('endDate', new Date());

    // change formik range value on tab click
    if (newTab === TIMEFRAME.DAY) {
      updateRangeValue(timeRangeConstants.TODAY);
    }
    if (newTab === TIMEFRAME.WEEK) {
      updateRangeValue(timeRangeConstants.LAST_WEEK);
    }
    if (newTab === TIMEFRAME.MONTH) {
      updateRangeValue(timeRangeConstants.LAST_MONTH);
    }
    if (newTab === TIMEFRAME.YEAR) {
      updateRangeValue(timeRangeConstants.YEAR_TO_DATE);
    }
    if (newTab === TIMEFRAME.CUSTOM) {
      updateRangeValue(timeRangeConstants.CUSTOM);
    }
  };

  return (
    <div>
      <Title>{t('Timeframe')}</Title>
      <SegmentedControl
        initialValue={currentTimeframe}
        values={timeframeOptions}
        onChange={newTab => onChangeHandler(newTab as TIMEFRAME)}
      />
    </div>
  );
};
